import { serviceConstants, errorConstants } from 'crisis-panic-button-view/src/utils/constant';

export const getAccessTokenHandler = () => {
  const token = JSON.parse(
    localStorage.getItem(serviceConstants.OKTA_TOKEN_KEY) as string
  )?.accessToken;
  if (token) {
    return token;
  } else {
    return ' ';
  }
};

export const getPagerdutyToken = async () => {
  try {
    const response = await fetch(process.env.REACT_APP_GET_PAGERDUTY_TOKEN_API as string, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getAccessTokenHandler().accessToken}`
      }
    });
    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    throw new Error(errorConstants.SERVER_ERROR);
  }
};

export const postPagerDutyOnGoingIncidentList = async (token: string) => {
  try {
    const response = await fetch(
      process.env.REACT_APP_POST_PAGERDUTY_ONGOING_INCIDENT_LIST_API as string,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getAccessTokenHandler().accessToken}`,
          'x-pagerduty-token': token
        }
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    throw new Error(errorConstants.SERVER_ERROR);
  }
};

export const postPagerDutyOnCallEngineer = async (token: string) => {
  try {
    const response = await fetch(
      process.env.REACT_APP_POST_PAGERDUTY_ONCALL_ENGINEER_API as string,
      {
        method: 'POST',
        body: JSON.stringify({ size: '1' }),
        headers: {
          Authorization: `Bearer ${getAccessTokenHandler().accessToken}`,
          'x-pagerduty-token': token
        }
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    throw new Error(errorConstants.SERVER_ERROR);
  }
};

export const postPagerDutyCreateIncident = async (token: string) => {
  try {
    const response = await fetch(
      process.env.REACT_APP_POST_PAGERDUTY_CREATE_INCIDENT_API as string,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getAccessTokenHandler().accessToken}`,
          'x-pagerduty-token': token
        }
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    throw new Error(errorConstants.SERVER_ERROR);
  }
};
